export const DEFAULT_STORAGE_URL = 'https://progress-storage.easygenerator.com';
export const USER_ALREADY_EXISTS = 'userAlreadyExists';
export const EMAIL_PASSWORD_COMBINATION_NOT_EXISTS = 'emailPasswordCombinationNotExists';
export const PASSWORD_RESET_SENDING_FAILED = 'passwordResetSendingFailed';
export const UNKNOWN_ERROR = 'unknownError';
export const STATUS_OK = 'statusOk';
